import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-wem-shift-bidding-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWemShiftBiddingIconProps extends SvgIconProps {}

/**
 * Component used to render WEM Shift Bidding tab Icon
 * @example
 */
export function CcfWemShiftBiddingIcon(props: CcfWemShiftBiddingIconProps) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M12 15.5C12.3 15.5 12.5 15.4 12.7 15.2L17.6 10.3C18 9.89998 18 9.29998 17.6 8.89998L15.5 6.79998C15.3 6.59998 15.1 6.49998 14.8 6.49998C14.5 6.49998 14.3 6.59998 14.1 6.79998L11.3 3.99998C11.7 3.59998 11.7 2.99998 11.3 2.59998L9.09999 0.399976C8.69999 -2.44081e-05 8.09999 -2.44081e-05 7.69999 0.399976L2.79999 5.29998C2.39999 5.69998 2.39999 6.29998 2.79999 6.69998L4.89999 8.79998C5.09999 8.99998 5.29999 9.09998 5.59999 9.09998C5.89999 9.09998 6.09999 8.99998 6.29999 8.79998L6.99999 9.59998L0.599988 16C0.199988 16.4 0.199988 17 0.599988 17.4C0.799988 17.6 1.09999 17.7 1.29999 17.7C1.49999 17.7 1.79999 17.6 1.99999 17.4L8.39999 11L9.09999 11.7C8.89999 11.9 8.79999 12.1 8.79999 12.4C8.79999 12.7 8.89999 12.9 9.09999 13.1L11.2 15.2C11.4 15.4 11.7 15.5 12 15.5ZM8.39999 2.49998L9.09999 3.19998L5.59999 6.79998L4.89999 6.09998L8.39999 2.49998ZM10.5 10.3L7.69999 7.49998L9.89999 5.29998L12.7 8.09998L10.5 10.3ZM14.8 8.89998L15.5 9.59998L12 13.1L11.3 12.4L14.8 8.89998Z"
        fill="#7D3CC8"
      />
      <path d="M11 18H20V20H11V18Z" fill="#7D3CC8" />
    </SvgIcon>
  );
}

export default CcfWemShiftBiddingIcon;
